<template>
  <div
    v-if="modelError"
    class="con-text-validation span-text-validation-danger vs-input--text-validation-span v-enter-to">
    <span class="span-text-validation" v-text="modelError ? modelError[0] : null"></span>
  </div>
</template>

<script>
export default {
  name: 'ValidationError',
  props: {
    modelError: {
      type: [Object, Array],
      required: false
    }
  }

}
</script>

<style scoped>

</style>
